import React, { useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { CustomInput } from "../CustomInput";
import Slider from "@material-ui/core/Slider";

// styles
import useStyles from "./styles";

const CustomRangeSlider = ({
  value,
  handleChange,
  valuetext,
  min,
  max,
  valueLabelDisplay,
  preInputText,
}) => {
  const styles = useStyles();
  const [inputMinFiledError, setInputFiledMinError] = useState("");
  const [inputMaxFiledError, setInputFiledMaxError] = useState("");

  const handleMinChange = (e) => {
    const newMin = Number(e.target.value);
    if (!isNaN(newMin)) {
      if (newMin <= value[1]) {
        setInputFiledMinError("");
        handleChange(null, [newMin, value[1]]);
      } else {
        setInputFiledMinError("Min must be less than or equal to Max");
      }
    }
  };

  const handleMaxChange = (e) => {
    const newMax = Number(e.target.value);
    if (!isNaN(newMax)) {
      if (newMax >= value[0]) {
        setInputFiledMaxError("");
        handleChange(null, [value[0], newMax]);
      } else {
        setInputFiledMaxError("Max must be greater than or equal to Min");
      }
    }
  };

  return (
    <Box className={styles.wrapperCustomRangeSlider}>
      <Slider
        className={styles.slider}
        value={[value[0], value[1]]}
        onChange={handleChange}
        valueLabelDisplay={valueLabelDisplay}
        getAriaLabel={() => "Range"}
        getAriaValueText={valuetext}
        min={min}
        max={max}
      />
      <Box className={styles.containerMinMax}>
        <Box className={styles.containerMin}>
          <Typography className={styles.MaxMineTitle}>Min</Typography>
          <CustomInput
            value={value[0]}
            onChange={handleMinChange}
            type="number"
            hasSearchIcon={false}
            style={{ maxWidth: "100%" }}
            errorMessage={inputMinFiledError}
            hasError={inputMinFiledError}
            submitted={inputMinFiledError}
            preInputText={preInputText}
          />
        </Box>
        <Typography className={styles.dashMark}>-</Typography>
        <Box className={styles.containerMin}>
          <Typography className={styles.MaxMineTitle}>Max</Typography>
          <CustomInput
            value={value[1]}
            onChange={handleMaxChange}
            type="number"
            hasSearchIcon={false}
            style={{ maxWidth: "100%" }}
            errorMessage={inputMaxFiledError}
            hasError={inputMaxFiledError}
            submitted={inputMaxFiledError}
            preInputText={preInputText}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CustomRangeSlider;
